import kamilkacki from "../assets/kamilkacki.png";
import bg from "../assets/bg.png";
import LazerZeroLogo from "../assets/LayerZero_Logo.png";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/footer";
import { CgChevronDoubleRight } from "react-icons/cg";

import DropdownComponent from "../components/Dropdown/dropdown";
import BridgeRightDropdown from "../components/BridgeRightDropdown/BridgeRightDropdown";
import Farmer from "../components/Farmer";
const Bridge: React.FC = () => {
  return (
    <div
      className="p-3 bg-fixed bg-center bg-no-repeat	flex flex-col min-h-screen"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Farmer />
      <Navbar />
      <div className="max-w-faqMax-width flex-grow w-full mx-auto bg-gradient-bg from-opacity-5 to-opacity-0 rounded-2xl p-3 md:p-5 md:px-8 text-white flex flex-col gap-2 mt-2 lg:mt-4">
        <h1 className="text-white text-24 md:text-xl font-bold tracking1 uppercase">
          mint and bridge
        </h1>
        <p className="text-dark_white text-sm mb-1 font-normal">
          Lorem ipsum dolor sit amet consectetur adipiscing elit sed doeius amod
          tempor incididunt ut labore et dolore magna aliqua.
        </p>
        <div className="flex justify-center">
          <img src={kamilkacki} alt="kamilkacki Man" width="40%" />
        </div>

        <h2 className="text-white text-24 md:text-xl font-bold tracking1 uppercase">
          NFT NAME
        </h2>
        <p className="text-dark_white text-sm mb-1 font-normal">
          Select your destination network below
        </p>

        <div className="flex justify-between items-center flex-col md:flex-row gap-5 md:gap-2 my-1 w-full">
          <DropdownComponent />

          <div>
            <CgChevronDoubleRight className="text-white text-lg md:rotate-0 rotate-90" />
          </div>

          <BridgeRightDropdown />
        </div>

        <hr className="w-full h-px border border-transparent_200 " />
        <ul className="flex justify-between items-center text-transparent_500 text-sm my-1">
          <li>Transaction Fee</li>
          <li>0.00025 ETH</li>
        </ul>

        <button className="w-full bg-vibrant_yellow rounded-xl text-black font-semibold text-base uppercase p-2">
          MINT & BRIDGE
        </button>

        <hr className="max-w-hrMax-width w-full h-px mx-auto border border-transparent_200 my-2" />
        <div className="flex justify-center items-center gap-2 opacity-20">
          <p className="text-white text-base font-normal">Powered by</p>
          <img src={LazerZeroLogo} alt="logo" width={100} height={32} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Bridge;
